"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
let RemoteVDDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.table_data = [];
  }
  close() {
    this.table_data = [];
    this._remote_dialog.hide();
  }
  open(data) {
    return __async(this, null, function* () {
      this.table_data = [];
      this.table_data.push(data);
      this._remote_dialog.show();
    });
  }
};
__decorateClass([
  Ref("remote-dialog")
], RemoteVDDialog.prototype, "_remote_dialog", 2);
RemoteVDDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], RemoteVDDialog);
export {
  RemoteVDDialog as default
};
